import React from 'react';
import { Grid, Typography } from '@mui/material';

import { Form } from 'mobx-react-form';
import { observer } from 'mobx-react-lite';

import { plugins } from 'forms/utils/formPlugins';
import { FormOptions, wrapForm } from 'components/shared/form';
import { formOptions } from 'forms/utils/formOptions';

import { useRootStore } from 'stores/RootStore';
import { UnderwritingOutput } from 'types/underwriting/underwriting';
import { settingsAndExportFormFields } from './settingsAndExportFormConfig';
import DocumentEditor from './DocumentEditor';

interface SettingsAndExportProps {
  form: Form;
}

const formConfig: FormOptions = {
  fields: settingsAndExportFormFields,
  options: {
    ...formOptions,
    validateOnChange: true,
  },
  plugins,
};

const SettingsAndExport: React.FC<SettingsAndExportProps> = observer(({ form }) => {
  const { underwritingPageStore } = useRootStore();
  const { underwritingData = {} as UnderwritingOutput } = underwritingPageStore;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Export</Typography>
      </Grid>
      <Grid item xs={12}>
        <DocumentEditor underwritingData={underwritingData} form={form} />
      </Grid>
    </Grid>
  );
});

export default wrapForm({
  ...formConfig,
})(SettingsAndExport);
